var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background"},[_c('a-icon',{staticClass:"back-arrow",attrs:{"type":"left"},on:{"click":_vm.back}}),_c('div',{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }